import React, { FC } from 'react'

import ErrorAlert from '../components/common/ErrorAlert'

const Single: FC = (props) => {
  const style = {
    root: {
      maxWidth: 980,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    html: {
      backgroundColor: "#FFFFFF",
    },
    'public-client-download': {
      'content-area': {
        backgroundColor: 'rgb(236, 240, 245)',
        position: 'relative',
        margin: '30px 60px',
        borderRadius: '6px',
        padding: '24px',
      },
    },
  }

  return (
    <>
      <div {...props} style={style.root} />
      <ErrorAlert />
    </>
  )
}

export default Single
